import * as Business   from '../business';
import * as ENV        from '../util/env';
import * as Forms      from '../components/forms';
import * as Phone      from 'libphonenumber-js';
import * as User       from '../user';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import classnames      from 'classnames';
import FetchFromServer from '../components/fetch_from_server';
import Navbar          from '../components/navbar';
import NotFoundPage    from '../components/not_found_page';
import React           from 'react';
import restrictAccess  from '../components/restrict_access';
import SaveOnChange    from '../components/save_on_change';
import SwitchControl   from '../components/switch_control';


export default connect(
  (state, { businessID }) => ({
    profile:      User.getProfile(state),
    businessID,
    business:     Business.getBusiness(state, businessID),
    statuses:     Business.getBusinessStatuses(state, businessID),
    twilioNumber: Business.getConnectedPhoneNumber(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load: compose(dispatch, Business.loadBusiness, () => (businessID)),
    save: compose(dispatch, User.updateProfile)
  })
)(restrictAccess(CallsPage, () => ENV.isWeb()));


function CallsPage({ business, profile, save, load, statuses, twilioNumber }) {
  const { callSetting }       = profile;
  const isIncomingCallEnabled = callSetting && callSetting.incoming !== 'none';
  const canSetSettings        = !!twilioNumber;

  if (business && !canSetSettings)
    return <NotFoundPage/>;

  return (
    <React.Fragment>
      {business && <Navbar title="Calls"/>}
      <FetchFromServer load={load} statuses={statuses}>
        {business && (
          <React.Fragment>
            <AcceptCalls isIncomingEnabled={isIncomingCallEnabled} save={save}/>
            <CallOptions {...{ profile, save, twilioNumber }}/>
          </React.Fragment>
        )}
      </FetchFromServer>
    </React.Fragment>
  );
}


function AcceptCalls({ isIncomingEnabled, save }) {
  async function saveAcceptCalls(accept) {
    const incoming = accept ? 'participating' : 'none';
    await save({ callSetting: { incoming } });
  }

  return (
    <div className="list block">
      <ul>
        <li className="item-content switch-item">
          <div className="item-inner">
            <div className="item-title">
              <span>Accept Calls</span>
              <div className="item-footer">You will receive calls if you are participating in the conversation.</div>
            </div>
            <div className="item-after">
              <SwitchControl
                checked={isIncomingEnabled}
                save={saveAcceptCalls}
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}


function CallOptions({ profile, save, twilioNumber }) {
  async function saveCallOption({ target }) {
    const { value } = target;
    await save({ callOption: value });
  }

  const className             = classnames('list', 'media-list', 'block');
  const formattedTwilioNumber = Phone.format(twilioNumber, 'National');
  const userPhone             = profile.phone && Phone.format(profile.phone, 'National');
  const hasWebRTCSupport      = ENV.isWebRTCSupported();

  return (
    <SaveOnChange className={className} save={saveCallOption}>
      {onChange => (
        <ul>
          <li className="list-group-title">Making and receiving calls</li>
          <li>
            <div className="item-content">
              Outgoing calls will show as {formattedTwilioNumber}.
            </div>
          </li>
          <Forms.Radio
            label="Use My Computer"
            name="callOption"
            value="browser"
            onChange={onChange}
            disabled={!hasWebRTCSupport}
            readOnly={!hasWebRTCSupport}
            defaultChecked={profile.callOption === 'browser'}>
            <div className="item-subtitle">
              {
                hasWebRTCSupport ?
                  'To receive a call, you must have an open browser window with Broadly.' :
                  'Your browser does not support making and receiving calls. Please upgrade to a newer browser. We support Chrome, Edge, Firefox and Safari.'
              }
            </div>
          </Forms.Radio>
          <Forms.Radio
            label="Use My Phone"
            name="callOption"
            value="phone"
            onChange={onChange}
            disabled={!userPhone}
            readOnly={!userPhone}
            defaultChecked={profile.callOption === 'phone'}>
            <div className="item-subtitle">
              {
                userPhone ?
                  'Outgoing calls will ring your phone first and then call the contact for you.' :
                  'To enable this option, add a phone number to your profile.'
              }
            </div>
          </Forms.Radio>
        </ul>
      )}
    </SaveOnChange>
  );
}
